import type { Event } from '@sentry/react';

// Qt WebEngine 5.11 stringifies a transferred MessagePort into targetOrigin
// when Google reCAPTCHA calls postMessage(message, [port]).
const RECAPTCHA_KIOSK_POST_MESSAGE_ERROR =
  /Invalid target origin '\[object MessagePort\]'/;

// Hosted reCAPTCHA release script, for example
// https://www.gstatic.com/recaptcha/releases/<hash>/recaptcha__en.js
const RECAPTCHA_RELEASE_SCRIPT = /\/recaptcha\/releases\//;

const exceptionMessages = (event: Event): string[] => {
  const messages: string[] = [];

  if (event.message) {
    messages.push(event.message);
  }

  for (const exception of event.exception?.values ?? []) {
    if (!exception.value) {
      continue;
    }

    messages.push(exception.value);
    if (exception.type) {
      messages.push(`${exception.type}: ${exception.value}`);
    }
  }

  return messages;
};

const stackFilenames = (event: Event): string[] => {
  const filenames: string[] = [];

  for (const exception of event.exception?.values ?? []) {
    for (const frame of exception.stacktrace?.frames ?? []) {
      if (frame.filename) {
        filenames.push(frame.filename);
      }
      if (frame.abs_path) {
        filenames.push(frame.abs_path);
      }
    }
  }

  return filenames;
};

// Drop the event only when the postMessage text and a recaptcha release frame both match.
export const dropRecaptchaKioskPostMessageNoise = (
  event: Event,
): Event | null => {
  const messageMatches = exceptionMessages(event).some((message) =>
    RECAPTCHA_KIOSK_POST_MESSAGE_ERROR.test(message),
  );
  const sourceMatches = stackFilenames(event).some((filename) =>
    RECAPTCHA_RELEASE_SCRIPT.test(filename),
  );

  return messageMatches && sourceMatches ? null : event;
};
